// src/pages/MaintenancePage.jsx
import React, { useEffect, useState } from 'react';
import '../styles/maintenance.css';
import logoImage from '../assets/logo.png';

const MaintenancePage = ({ message, estimatedTime }) => {
  const [dots, setDots] = useState('');

  // Animation des points de chargement
  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.');
    }, 500);

    return () => clearInterval(interval);
  }, []);

  // Fonction pour réessayer
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="maintenance-container">
      <div className="maintenance-content">
        
        {/* Logo de l'application */}
        <div className="maintenance-logo-container">
          <img src={logoImage} alt="Boissons du Cameroun" className="maintenance-logo" />
        </div>

        {/* Icône de maintenance animée */}
        <div className="maintenance-icon-wrapper">
          <div className="maintenance-icon-circle">
            <svg 
              className="maintenance-icon" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Clé à molette */}
              <path 
                d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" 
                fill="currentColor"
                className="tool-icon"
              />
            </svg>
          </div>
          
          {/* Engrenages décoratifs */}
          <svg className="gear gear-1" viewBox="0 0 100 100">
            <path d="M50,10 L54,20 L64,20 L56,28 L60,38 L50,32 L40,38 L44,28 L36,20 L46,20 Z M50,90 L54,80 L64,80 L56,72 L60,62 L50,68 L40,62 L44,72 L36,80 L46,80 Z" fill="currentColor" opacity="0.1"/>
          </svg>
          <svg className="gear gear-2" viewBox="0 0 100 100">
            <path d="M50,10 L54,20 L64,20 L56,28 L60,38 L50,32 L40,38 L44,28 L36,20 L46,20 Z M50,90 L54,80 L64,80 L56,72 L60,62 L50,68 L40,62 L44,72 L36,80 L46,80 Z" fill="currentColor" opacity="0.1"/>
          </svg>
        </div>

        {/* Titre principal */}
        <h1 className="maintenance-title">
          🔧 Maintenance en cours
        </h1>

        {/* Message personnalisé */}
        <div className="maintenance-message">
          <p>
            {message || 'Notre service de livraison est temporairement indisponible pour amélioration.'}
          </p>
        </div>

        {/* Badge "Nous serons bientôt de retour" */}
        <div className="maintenance-badge">
          <span className="badge-icon">⚡</span>
          <span className="badge-text">Nous serons de retour très bientôt</span>
        </div>

        {/* Heure estimée si disponible */}
        {estimatedTime && (
          <div className="maintenance-estimate">
            <svg className="clock-icon" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <span>Retour estimé : {estimatedTime}</span>
          </div>
        )}

        {/* Animation de chargement */}
        <div className="maintenance-loading">
          <div className="loading-bar">
            <div className="loading-progress"></div>
          </div>
          <p className="loading-text">Vérification{dots}</p>
        </div>

        {/* Bouton réessayer */}
        <button 
          className="maintenance-retry-btn"
          onClick={handleRetry}
        >
          <svg className="retry-icon" viewBox="0 0 24 24" fill="none">
            <path 
              d="M1 4v6h6M23 20v-6h-6M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
          Réessayer
        </button>

        {/* Message de support */}
        <div className="maintenance-support">
          <p className="support-text">
            Besoin d'aide urgente ? Contactez-nous :
          </p>
          <a href="tel:+237" className="support-phone">
            📞 +237 686 12 78 82
          </a>
        </div>

        {/* Footer */}
        <div className="maintenance-footer">
          <p>Merci pour votre patience 🙏</p>
          <p className="footer-brand">Boissons du Cameroun</p>
        </div>

      </div>
    </div>
  );
};

export default MaintenancePage;